<ng-container *transloco="let t">
    <div
        class="container"
        fxLayout="row"
        fxLayoutAlign.xs="center"
        fxLayoutAlign.sm="center"
    >
        <div
            fxLayout="row"
            fxLayout.xs="column"
            fxLayout.sm="column"
            fxFlex.xs="90%"
            fxFlex.sm="90%"
            fxLayoutAlign="space-between start"
            fxLayoutAlign.xs="space-between center"
            fxLayoutAlign.sm="space-between center"
        >
            <h1 class="visually-hidden">
                {{ t("application.tab.background") }}
            </h1>
            <div
                fxFlex="612px"
                fxLayoutAlign="center center"
                class="left-area"
                fxFlex.xs="100"
                fxFlex.sm="100"
            >
                <mat-card appearance="outlined">
                    <img
                        src="assets/img/application-icons/demographics-icon.svg"
                        alt="demographics-icon"
                    />
                    <h2>{{ t("application.background.header") }}</h2>
                    <form
                        [formGroup]="backgroundForm"
                        (ngSubmit)="onSubmitted()"
                        fxLayout="column"
                    >
                        @if (formSections$ | async; as sections) { @for (section
                        of sections; track section; let i = $index) {
                        <div #sectionWrapper>
                            @if (isSectionVisible(section)) { @if (i > 0) {
                            <mat-divider></mat-divider>
                            } @if ( section.title || section.titleKey ||
                            section.flyoutKey ) {
                            <div class="sub-title">
                                @if ( section.title || section.titleKey ) {
                                <h3>
                                    {{
                                        t(
                                            section.titleKey ??
                                                section.title ??
                                                section.key ??
                                                ""
                                        )
                                    }}
                                </h3>
                                }
                                <app-section-flyout
                                    [flyoutKey]="section.flyoutKey"
                                    [active]="activeFlyoutIndex === i"
                                    [flipUp]="
                                        flyoutFlipUp && activeFlyoutIndex === i
                                    "
                                />
                            </div>
                            } @if ( section.description ||
                            section.descriptionKey ) {
                            <p>
                                {{
                                    t(
                                        section.descriptionKey ??
                                            section.description ??
                                            ""
                                    )
                                }}
                            </p>
                            } @for (row of section.rows; track row) {
                            <div>
                                <app-dynamic-form
                                    [formGroup]="backgroundForm"
                                    [fields]="row.fields"
                                    [formSubmitted]="submitted"
                                    [sectionValidators]="
                                        getSectionValidators(section)
                                    "
                                >
                                </app-dynamic-form>
                            </div>
                            } @for ( validator of getSectionErrors( section ) ;
                            track validator.errorKey ?? validator.name) {
                            <mat-error>
                                {{
                                    t(
                                        validator.messageKey ??
                                            validator.message ??
                                            validator.name
                                    ) ??
                                        validator.messageKey ??
                                        validator.message
                                }}
                            </mat-error>
                            } }
                        </div>
                        } }

                        <button
                            mat-stroked-button
                            class="submit"
                            type="submit"
                            [disabled]="submitting"
                        >
                            {{ t("application.save-and-continue") }}
                        </button>
                    </form>
                </mat-card>
            </div>
            <div
                fxFlex="334px"
                fxLayoutAlign="center center"
                class="right-area"
                fxFlex.xs="100"
                fxFlex.sm="100"
                fxHide.xs
                fxHide.sm
            ></div>
        </div>
    </div>
</ng-container>
